<template>
  <div style="position: relative">
    <input
      v-if="isCreationTimestamp || visibility > 0"
      :value="dateTimeString"
      class="asd-input"
      disabled="disabled"
    />
    <input
      v-else
      :value="dateTimeString"
      class="asd-input"
      @click="pickerOpen = true"
      @blur="closePicker"
      @keydown="onKeypress"
    />
    <transition name="fade">
      <DateTimePicker
        v-if="pickerOpen"
        v-model="valueHandler"
        :showTimePicker="false"
        :locked="pickerLocked"
        @closePicker="closePicker"
        @lockChange="lockChange"
      />
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import DateTimePicker from 'CORE/components/utilities/date-time-picker'
import { DATE_FORMAT } from 'CORE/utils/date'
import DataTypeProsMixin from 'CORE/mixins/dataType'
import { createDataTypeValue } from '../utils'

export default {
    name: 'DateInput',
    components: {
        DateTimePicker,
    },
    mixins: [
        DataTypeProsMixin,
    ],
    data() {
        return {
            date: undefined,
            pickerOpen: false,
            pickerLocked: false,
        }
    },
    computed: {
        valueHandler: {
            get() {
                return _.get(this, 'value.value.value', undefined)
            },
            set(value) {
                this.$emit('input', createDataTypeValue(value))
            },
        },
        isCreationTimestamp() {
            return _.get(this, 'propertyType.settings.systags.creationTimestamp', false)
        },
        dateTimeString() {
            if (this.valueHandler === undefined || this.valueHandler === null) {
                return ''
            }
            return moment(this.valueHandler, 'X').format(DATE_FORMAT)
        },
    },
    methods: {
        onChange(data) {
            this.valueHandler = _.parseInt(moment(data.startDate).format('X'))
        },
        lockChange(value) {
            this.pickerLocked = value
        },
        closePicker(e) {
            if (this.pickerLocked === false) {
                this.pickerOpen = false
            }
        },
        onKeypress(e) {
            if (e.key === 'Backspace' || e.key === 'Delete') {
                this.$emit('delete')
                e.preventDefault()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 250ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
